@use "../../styles/breakpoint.module.scss" as *;
@use "./Header.module" as *;

.mobileNav {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 10;
    height: $mobile-nav-height;
    translate: 0 0;
    transition:
        translate 0.3s,
        background-color 0.3s,
        color 0.3s;
}

.isOpen {
    width: calc(100vw - 16px);
}

.hidden {
    translate: 0 -100%;
}

.layoutUnset {
    opacity: 0;

    @media ($above-mobile) {
        position: absolute;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
    }
}

.layoutSet {
    opacity: 1;
}

.inner {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
}

.logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0;
}

.logoSvg {
    width: 64px;
    height: auto;
    fill: currentcolor;
}

.actions {
    display: flex;
    align-items: center;
    transform: translateX(8px);
}

.actionButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 8px;
    color: inherit;
}

.favoritesActionButton {
    composes: actionButton;
    padding: 11px;
}

.actionIcon {
    width: 100%;
    height: 100%;
    fill: currentcolor;
}

.actionIconFilled {
    --heart-fill: 100%;
}
